// @flow
import { pushUrl } from "../services/history/historyActions"
import bindWindowGlobalFunctions from "../../../app/scripts/tools/bindWindowGlobalFunctions"
import { updateGlobals } from "../../../app/scripts/tools/translate"
import { setLocale, getTranslations } from "../services/intl"

// Due to 404 tracking
function initHistory(store: *) {
  store.dispatch(pushUrl(window.location.href))
}

function applyTranslations(store: *) {
  const { translations } = window.__INTL__
  if (__DEV__ && !translations) console.warn("missing translations")
  store.dispatch(setLocale(translations))

  const fedTranslations = getTranslations(store.getState())
  updateGlobals(fedTranslations)
}

export default function preRender(store: *) {
  initHistory(store)
  applyTranslations(store)
  bindWindowGlobalFunctions()
}
